"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __spreadArrays = this && this.__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) {
    s += arguments[i].length;
  }

  for (var r = Array(s), k = 0, i = 0; i < il; i++) {
    for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) {
      r[k] = a[j];
    }
  }

  return r;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var util_1 = require("./util");

var TSPSDK =
/** @class */
function () {
  /**
   * 构造函数
   * @param options.name - SDK实例名称
   *
   */
  function TSPSDK(options) {
    /**
     * 从TSP API 获取翻译的超时毫秒数
     * @type {number}
     */
    this.timeout = 3000;
    /**
     * 用于区分live/non-live的TSP API, 默认live
     * @type {string}
     */

    this.env = 'live';
    /**
     *
     * 是否是mainland，用于CDN地址选择
     * @type {boolean}
     */

    this.isMainland = undefined;
    /**
     * 切换语言时用来重新渲染页面
     * @type {function}
     */

    this.forceUpdate = function () {};
    /**
     * 自定义的替换特殊字符
     * @type {function}
     */


    this.replacer = function (content) {
      return content;
    };
    /**
     * 存储通过调用 mergeLocale 方法的翻译数据 形如 {en: {ps_home: 'Home'}}
     * @type {SimpleObject}
     */


    this.commonCache = {};
    /**
     *
     * 当前模块名称 例如 finance
     * @private
     * @type {string}
     */

    this.currentModuleName = '';
    /**
     *
     * 基础模块 例如 framework
     * @private
     * @type {TspModules}
     */

    this.baseModules = {};
    /**
     *
     * 所有业务模块 例如 finance、account
     * @private
     * @type {TspModules}
     */

    this.modules = {};

    if (options && options.name) {
      this.name = options.name;
    }
  }
  /**
   * 初始化TSPSDK
   * @param options.locale - 当前语言类型
   * @param [options.isMainland] - 用于选择CDN地址
   * @param [options.baseModules] - 基本模块，例如 framework
   * @param [options.forceUplate] - 切换语言时用来重新渲染页面
   */


  TSPSDK.prototype.create = function (options) {
    var _this = this;

    if (options.locale !== undefined) {
      TSPSDK.locale = options.locale;
    }

    if (options.env !== undefined) {
      this.env = options.env;
    }

    if (options.timeout !== undefined) {
      this.timeout = options.timeout;
    }

    this.isMainland = options.isMainland;
    this.forceUpdate = options.forceUplate || this.forceUpdate;
    this.replacer = options.replacer || this.replacer;

    if (options.baseModules && options.baseModules.length) {
      options.baseModules.map(function (module) {
        _this.mergeModule(_this.baseModules, module);
      });
      return this.getTranslationByModules(TSPSDK.locale, this.baseModules).then(function () {
        return true;
      });
    }

    return Promise.resolve(true);
  };
  /**
   * 获取当前的模块信息
   */


  TSPSDK.prototype.getCurrentModule = function () {
    return this.modules[this.currentModuleName];
  };
  /**
   *
   *
   * 返回TSPSDK中存储的所有模块信息
   */


  TSPSDK.prototype.getAllModules = function () {
    return __assign(__assign({}, this.baseModules), this.modules);
  };
  /**
   * 切换语言，并拉取相关的翻译数据
   * moduleNames: 例如['listing', 'drc']
   * @param {string} locale
   * @param {string[]} [moduleNames]
   */


  TSPSDK.prototype.switchLanguage = function (locale, moduleNames) {
    var _this = this; // 先计算需要拉取的模块，如果没传moduleNames，将拉取所有模块翻译


    var allModules = this.getAllModules();
    var requiedModules = {};

    if (moduleNames) {
      moduleNames.map(function (name) {
        requiedModules[name] = allModules[name];
      });
      requiedModules = __assign(__assign({}, this.baseModules), requiedModules);
    }

    return this.getTranslationByModules(locale, moduleNames ? requiedModules : allModules).then(function () {
      TSPSDK.locale = locale;

      if (_this.forceUpdate && typeof _this.forceUpdate === 'function') {
        setTimeout(function () {
          _this.forceUpdate();
        }, 0);
      }

      return true;
    });
  };
  /**
   * 切换模块，并拉取相关的翻译数据
   * @param {TspModule} module
   */


  TSPSDK.prototype.switchModule = function (module) {
    if (!module.name) {
      throw new Error('module must have a name');
    }

    this.currentModuleName = module.name;
    this.mergeModule(this.modules, module);
    return this.getTranslationByModule(TSPSDK.locale, module);
  };
  /**
   * 合并额外的翻译数据
   * @param {string} locale
   * @param {Message} message
   */


  TSPSDK.prototype.mergeLocale = function (locale, message) {
    this.commonCache[locale] = this.commonCache[locale] || {};

    for (var k in message) {
      if (Object.prototype.hasOwnProperty.call(message, k)) {
        this.commonCache[locale][k] = message[k];
      }
    } // this.commonCache[locale] = {...this.commonCache[locale], ...message};

  };
  /**
   * 返回翻译字符串
   * @param {string} key
   * @param {number | SimpleObject | Array<any>} [count]
   * @param {SimpleObject | Array<any>} [values]
   */


  TSPSDK.prototype.$t = function (key, count, values) {
    return this._$t(key, count, values);
  };
  /**
   * 建议使用 $t
   * 返回单复数形式的key的翻译字符串
   * @param {string} key
   * @param {number | SimpleObject | Array<any>} [count]
   * @param {SimpleObject | Array<any>} [values]
   */


  TSPSDK.prototype.$tc2 = function (key, count, values) {
    return this._$t(key, count, values);
  };
  /**
   * 用于i18n组件
   * @param {string} key
   * @param {object} values
   * @returns {Array<any>}
   */


  TSPSDK.prototype.$i = function (key, values) {
    return this._$t(key, '__null', values, 'raw');
  };
  /**
   * 返回翻译字符串
   * @param {string} key
   * @param {number | SimpleObject | Array<any>} [count]
   * @param {SimpleObject | Array<any>} [values]
   */


  TSPSDK.prototype._$t = function (key, count, values, mode) {
    if (mode === void 0) {
      mode = 'string';
    }

    count = Number(count) || count; // 兼容count传了字符串类型的数字. 如: $t('ps_', '1')

    if (values) {
      count = count || 0; // 解决没有传count, 但是传了values的情况. 如: $t('ps_', undefined, {count: 1})
    }

    if (count !== null && typeof count === 'object') {
      values = count; // 当只传了两个参数，那么第二个参数应该是values
    }

    var result = this.__$t(key, typeof count === 'number' ? undefined : values, mode);

    if (typeof result === 'string' || mode === 'raw') {
      return result;
    } else if (typeof result === 'object' && typeof count === 'number') {
      if (count === 0) {
        return this.__$t(result.zero || result.one || result.other, values, mode);
      } else if (count === 1) {
        return this.__$t(result.one, values, mode);
      } else {
        return this.__$t(result.other, values, mode);
      }
    }

    return key;
  };
  /**
   * @param {string} key
   * @param {SimpleObject | Array<any>} values
   * @param {string} mode ['string' | 'raw']
   * @returns {string | Array<any>}
   */


  TSPSDK.prototype.__$t = function (key, values, mode) {
    if (!key) {
      return '';
    }

    var result = this.getTranslationByKey(key) || key;

    if (this.replacer) {
      try {
        result = this.replacer(result);
      } catch (e) {
        console.error('TSPSDK replacer error: ', e);
      }
    }

    return values ? util_1.interpolate(result, values, mode) : result;
  };
  /**
   * 获取某个resource或collection的特定key的翻译数据
   * 返回promise，翻译数据会自动merge到翻译数据，因此不用关注返回值
   * @param {string} locale
   * @param {SourceType} type [resource | colletion]
   * @param {number} id
   * @param {string} keys [如果多个key，以逗号分隔]
   */


  TSPSDK.prototype.getTranslationByKeys = function (locale, type, id, keys) {
    var _this = this;

    var cache = this.getCache(type, id, locale);

    if (cache) {
      return Promise.resolve(cache);
    }

    return this.getTranslationFromAPI(type, id, locale, keys).then(function (res) {
      return Promise.resolve(res);
    }).catch(function () {
      return _this.getTranslationByType(type, id, locale);
    });
  };
  /**
   * @private 拉取多个模块的翻译
   * @param {string} locale
   * @param {TspModules} modules
   * @returns Promise
   */


  TSPSDK.prototype.getTranslationByModules = function (locale, modules) {
    var _this = this;

    var promises = Object.keys(modules).map(function (name) {
      return _this.getTranslationByModule(locale, _this.getAllModules()[name]);
    });
    return Promise.all(promises);
  };
  /**
   * 拉取一个模块的翻译
   * @param {string} locale
   * @param {module.name}
   * @param {module.resources} 如 [52]
   * @param {module.collections} 如 [2]
   * @returns {Promise}
   */


  TSPSDK.prototype.getTranslationByModule = function (locale, module) {
    var _this = this;

    if (!module) {
      console.error('TSPSDK.getTranslationByModule has no module');
      return Promise.resolve([]);
    }

    var collectionPromises = [];
    var resourcePromises = [];

    if (module.collections && module.collections.length) {
      collectionPromises = module.collections.map(function (id) {
        return _this.getTranslationByType('collection', id, locale);
      });
    }

    if (module.resources && module.resources.length) {
      resourcePromises = module.resources.map(function (id) {
        return _this.getTranslationByType('resource', id, locale);
      });
    }

    if (module.lazyResources && module.lazyResources.length) {
      setTimeout(function () {
        module.lazyResources.map(function (id) {
          _this.getTranslationByType('resource', id, locale);
        });
      }, module.lazyTime || 3000);
    }

    if (module.lazyCollections && module.lazyCollections.length) {
      setTimeout(function () {
        module.lazyCollections.map(function (id) {
          _this.getTranslationByType('collection', id, locale);
        });
      }, module.lazyTime || 3000);
    }

    return Promise.all(__spreadArrays(collectionPromises, resourcePromises)).then(function (res) {
      return res.reduce(function (p, c) {
        return __assign(__assign({}, p), c);
      }, {});
    });
  };
  /**
   * 根据传入的resource和collection id列表拉取翻译
   * @param {string} locale
   * @param {options.resources} number[]
   * @param {options.collections} number[]
   * @returns Promise
   */


  TSPSDK.prototype.getTranslations = function (locale, options) {
    options.name = '__' + Date.now();
    return this.getTranslationByModule(locale, options);
  };

  TSPSDK.prototype.getTranslationByType = function (type, id, locale) {
    var _this = this;

    var cache = this.getCache(type, id, locale);

    if (cache) {
      return Promise.resolve(cache);
    }

    return new Promise(function (resolve) {
      var cdnTimer;

      if (_this.timeout !== 0) {
        // 如果timeout === 0，则直接请求cdn，不请求api
        _this.getTranslationFromAPI(type, id, locale).then(function (res) {
          if (JSON.stringify(res) === '{}') {
            console.error('TSPSDK get translation from API result empty', type, id, locale);
            throw new Error('TSPSDK get translation from API result empty');
          }

          cdnTimer && clearTimeout(cdnTimer);
          resolve(res);
        });
      }

      if (typeof _this.timeout === 'number') {
        // timeout 可能为0
        cdnTimer = setTimeout(function () {
          _this.getTranslationFromCDN(type, id, locale).then(function (res) {
            if (JSON.stringify(res) === '{}') {
              console.error('TSPSDK get translation from CDN result empty', type, id, locale);
              throw new Error('TSPSDK get translation from CDN result empty');
            }

            resolve(res);
          }).catch(function (e) {
            console.error('TSPSDK get translation from CDN fail', e);
            resolve(_this.getTranslationFromAPI(type, id, locale)); // 如果cdn失败了 再从api请求数据
          });
        }, _this.timeout);
      }
    });
  };

  TSPSDK.prototype.getTranslationFromAPI = function (type, id, locale, keys) {
    var _a;

    var _this = this;

    var params = (_a = {}, _a[type + '_id'] = id, _a.language = locale, _a);

    if (keys) {
      params.keys = keys;
    }

    return util_1.get(this.getTspAPI(), params).then(function (res) {
      if (keys) {
        _this.mergeLocale(locale, res);
      } else {
        _this.setCache(type, id, locale, res);
      }

      return res;
    });
  };

  TSPSDK.prototype.getTspAPI = function () {
    if (this.env.indexOf('live') > -1) {
      return 'https://seller.shopee.sg/api/tsp/transify';
    }

    return 'https://seller.shopee.sg/api/tsp/nonlive/transify';
  };

  TSPSDK.prototype.getTranslationFromCDN = function (type, id, locale) {
    var _this = this;

    var fileName = this.getCacheKey(id, locale) + '.json';
    var url = this.getCdnPrefix() + type[0] + '_' + fileName;
    return util_1.get(url).then(function (res) {
      _this.setCache(type, id, locale, res);

      return res;
    });
  };

  TSPSDK.prototype.getCacheKey = function (id, locale) {
    return id + '_' + locale.toLowerCase();
  };

  TSPSDK.prototype.getCdnPrefix = function () {
    var cdnUrlConfig = {
      cn: 'https://deo.shopeesz.com/shopee/shopee-seller-live-sg/tsp/api/',
      sea: 'https://deo.shopeemobile.com/shopee/shopee-seller-live-sg/tsp/api/'
    };
    return cdnUrlConfig[this.isCN() ? 'cn' : 'sea'];
  };

  TSPSDK.prototype.isCN = function () {
    if (this.isMainland !== undefined) {
      return this.isMainland;
    }

    var host = window.location.host;
    return host.slice(-2) === 'cn';
  };

  TSPSDK.prototype.setCache = function (type, id, locale, message) {
    var cache = type === 'resource' ? TSPSDK.resourceCache : TSPSDK.collectionCache;
    var key = this.getCacheKey(id, locale); // for example: 52en

    cache[key] = cache[key] || {};
    cache[key] = __assign(__assign({}, cache[key]), message);
  };

  TSPSDK.prototype.getCache = function (type, id, locale) {
    var cache = type === 'resource' ? TSPSDK.resourceCache : TSPSDK.collectionCache;
    var key = this.getCacheKey(id, locale); // for example: 52en

    return cache[key];
  };

  TSPSDK.prototype.getTranslationByKey = function (key) {
    var result;
    var currentModule = this.getCurrentModule();

    if (currentModule) {
      result = this.findTranslationFromModule(key, currentModule);

      if (result) {
        return result;
      }
    }

    var baseModuleNames = Object.keys(this.baseModules);

    for (var i = 0; i < baseModuleNames.length; i++) {
      var name_1 = baseModuleNames[i];
      result = this.findTranslationFromModule(key, this.baseModules[name_1]);

      if (result) {
        return result;
      }
    }

    result = this.findTranslationFromCommon(key);

    if (result) {
      return result;
    }

    var allModules = this.getAllModules();
    var allModuleNames = Object.keys(allModules);

    for (var i = 0; i < allModuleNames.length; i++) {
      var name_2 = allModuleNames[i];
      result = this.findTranslationFromModule(key, allModules[name_2]);

      if (result) {
        return result;
      }
    }

    return result || '';
  };

  TSPSDK.prototype.findTranslationFromModule = function (key, module) {
    var collections = (module.collections || []).concat(module.lazyCollections || []);
    var resources = (module.resources || []).concat(module.lazyResources || []);

    for (var i = 0; i < collections.length; i++) {
      var cache = this.getCache('collection', collections[i], TSPSDK.locale);

      if (cache && cache[key]) {
        return cache[key];
      }
    }

    for (var i = 0; i < resources.length; i++) {
      var cache = this.getCache('resource', resources[i], TSPSDK.locale);

      if (cache && cache[key]) {
        return cache[key];
      }
    }

    return '';
  };

  TSPSDK.prototype.findTranslationFromCommon = function (key) {
    var cache = this.commonCache[TSPSDK.locale];

    if (cache && cache[key]) {
      return cache[key];
    }

    return '';
  };

  TSPSDK.prototype.mergeModule = function (modules, module) {
    var current = modules[module.name];

    if (!current) {
      modules[module.name] = module;
      return;
    }

    current.collections = current.collections || [];
    current.resources = current.resources || [];
    module.collections = module.collections || [];
    module.resources = module.resources || [];
    module.collections.map(function (id) {
      if (current.collections.indexOf(id) === -1) {
        current.collections.push(id);
      }
    });
    module.resources.map(function (id) {
      if (current.resources.indexOf(id) === -1) {
        current.resources.push(id);
      }
    });
  };
  /**
   * 当前的语言类型
   */


  TSPSDK.locale = 'en';
  /**
   * 按resource id + locale存储翻译数据 形如 {52en: {ps_home: 'Home'}}
   * @type {ResourceCache}
   */

  TSPSDK.resourceCache = {};
  /**
   *
   * 按collection id + locale存储翻译数据 形如 {33en: {ps_home: 'Home'}}
   * @type {ResourceCache}
   */

  TSPSDK.collectionCache = {};
  return TSPSDK;
}();

exports.default = TSPSDK;